export default __webpack_public_path__ + "static/media/Investment.7ef3e07f.JPG";